import { NgModule } from '@angular/core';
import { ReferenceCodeShowNamePipe} from './reference-code-show-name.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { InsertErrorMessagePipe } from './validation-error-message.pipe';
import {MyFilterPipe} from './my-filter.pipe';
import {ClickOutsideDirective} from './click-outside.directive'
import { NewLineFilterPipe } from './newline-filter.pipe';
import { HasPartyPipe } from './has-party.pipe';
@NgModule({
    imports: [],
    declarations: [ReferenceCodeShowNamePipe, DateFormatPipe, InsertErrorMessagePipe,MyFilterPipe,ClickOutsideDirective,NewLineFilterPipe,HasPartyPipe],
    exports: [ReferenceCodeShowNamePipe, DateFormatPipe, InsertErrorMessagePipe,MyFilterPipe,ClickOutsideDirective,NewLineFilterPipe,HasPartyPipe],
    providers:[DateFormatPipe, InsertErrorMessagePipe,MyFilterPipe,ClickOutsideDirective]
})
export class AllPipesModule { }